<div id="sportsoccer_div" [ngStyle]="fixtureStyles.mainContainer" onscroll="Scroll_Table()">

  <div class="ui table SportBets_Tables" [ngStyle]="fixtureStyles.tableNoNBorder">

    <virtual-scroller #scroll [items]="mergedData" [enableUnequalChildrenSizes]="true" [bufferAmount]="_bufferAmount"
      [ngStyle]="styles.virtualScroll" class="{{ isScoreBox ? 'ScrollBar' : ''}}">
      <div class="container" *ngFor="let event of dataArray">
        <!-- Başlık -->
        <h2 class="title">{{ event.EventName }}</h2>

        <!-- Tablo -->
        <div class="table">
          <ng-container *ngFor="let odd of event.Odds">
            <div class="row" [ngClass]="{'selected': checkSelected(odd?.OddId) }">
              <div class="row_value" (click)="clickOddUP(odd,true)">
                {{ odd.OutCome }}
                <span class="value">{{ odd.OddValue }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </virtual-scroller>
  </div>
</div>
<style>
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
</style>
